import CollapsibleListCard from "../CollapsibleListCard";
import useHistoricoPessoasCardColumns from "./../../hooks/useHistoricoPessoasCardColumns";
import { useState } from "react";
import { useDisclosure } from "@chakra-ui/react";
import ModalCadastroPessoaUnidade from "components/Features/Unidades/components/ModalCadastroPessoaUnidade";
import ModalCadastroPessoaJuridicaUnidade from "components/Features/Unidades/components/ModalCadastroPessoaJuridicaUnidade";
import useUnidadePessoasHistorico from "core/features/unidades/useUnidadePessoasHistorico";
import PrimaryButton from "components/Button/PrimaryButton";
import { PessoaTipo } from "features/pessoas/typings";
import { useInvalidateQuery } from "infra/packages/react-query/index";
import { UnidadePessoaHistorico } from "core/features/unidades/typings/unidade";
import ModalContentPessoa from "./ModalContentPessoa/index";

function CardHistoricoPessoas({
  unidadeId,
  tenantId,
}: {
  unidadeId: string;
  tenantId: string;
}) {
  const { data, isLoading } = useUnidadePessoasHistorico({ unidadeId });
  const [changeProprietario, setChangeProprietario] = useState<boolean>(false);

  const { doInvalidateQueryWithStringKey } = useInvalidateQuery();

  const {
    isOpen: isOpenPessoaFisicaModal,
    onToggle: onTogglePessoaFisicaModal,
  } = useDisclosure();

  const {
    isOpen: isOpenPessoaJuridicaModal,
    onToggle: onTogglePessoaJuridicaModal,
  } = useDisclosure();

  const [id, setId] = useState<string | undefined>();

  const handleToggleOpenModal = (pessoaTipo: PessoaTipo) => {
    if (pessoaTipo === PessoaTipo.Juridica) {
      onTogglePessoaJuridicaModal();
    } else {
      onTogglePessoaFisicaModal();
    }
  };

  return (
    <>
      <CollapsibleListCard
        unidadeId={unidadeId}
        isLoading={isLoading}
        showHeader
        value={data?.items.length ?? 0}
        singularTitleText="histórico de pessoa"
        getDataHook={useUnidadePessoasHistorico}
        useColumnsHook={useHistoricoPessoasCardColumns}
        button={
          <PrimaryButton
            isLoading={isLoading}
            w="fit-content"
            ml="auto"
            onClick={() => {
              handleToggleOpenModal(PessoaTipo.Fisica);
              setChangeProprietario(true);
            }}
          >
            Trocar Proprietário
          </PrimaryButton>
        }
        onRow={(v: UnidadePessoaHistorico) => ({
          onClick: () => {
            setId(v.pessoaId);
          },
          style: {
            cursor: "pointer",
          },
        })}
        children={
          <>
            {isOpenPessoaFisicaModal ? (
              <ModalCadastroPessoaUnidade
                changeProprietario={changeProprietario}
                onSaved={() => {
                  setId(undefined);
                  onTogglePessoaFisicaModal();
                  doInvalidateQueryWithStringKey(`/v1/unidades/${unidadeId}`);
                  setChangeProprietario(false);
                }}
                id={id}
                isOpen={isOpenPessoaFisicaModal}
                onClose={() => {
                  setId(undefined);
                  setChangeProprietario(false);
                  onTogglePessoaFisicaModal();
                }}
                unidadeId={unidadeId}
                tenantId={tenantId}
              />
            ) : null}

            {isOpenPessoaJuridicaModal ? (
              <ModalCadastroPessoaJuridicaUnidade
                onSaved={() => {
                  setId(undefined);
                  onTogglePessoaJuridicaModal();
                  doInvalidateQueryWithStringKey(`/v1/unidades/${unidadeId}`);
                }}
                id={id}
                isOpen={isOpenPessoaJuridicaModal}
                onClose={() => {
                  setId(undefined);
                  onTogglePessoaJuridicaModal();
                }}
                unidadeId={unidadeId}
              />
            ) : null}
          </>
        }
      />
      <ModalContentPessoa
        isOpenModal={!!id}
        onClose={() => setId(undefined)}
        id={id}
        unidadeId={unidadeId}
      />
    </>
  );
}

export default CardHistoricoPessoas;
